"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const divider = {
    MuiDivider: {
        styleOverrides: {
            root: {
                borderColor: colors_1.default.border[800],
                "&:before, &:after": {
                    borderTopColor: colors_1.default.border[800],
                },
            },
        },
    },
};
exports.default = divider;
